import { Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

import { SCROLLABLE_LIST_ROW_HEIGHT } from '../../constants/scrollableListRowHeight'

interface ScrollableListItemWrapperProps {
  disabled?: boolean
  highlighted?: boolean
}

export const ScrollableListItemWrapper = styled.label<ScrollableListItemWrapperProps>`
  display: flex;
  align-items: center;
  width: 100%;
  height: ${SCROLLABLE_LIST_ROW_HEIGHT}px;
  margin-top: -${Spacing.S2};
  padding: 0 ${Spacing.S24} 0 ${Spacing.S16};
  border-bottom: 1px solid ${Color.Grey150};
  position: relative;
  background-color: ${({ highlighted }) => highlighted && Color.Grey100};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};

  &:hover {
    background-color: ${Color.Grey100};
  }
`
